import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { createStructuredSelector } from 'reselect';
import { Button } from 'vx-ui-components';
import { Flex, Box } from 'reflexbox';
import request from 'vx-commons/lib/utils/request';
import Growler from '../../containers/Notification';
import { spinner } from 'vx-commons/lib/utils/icons';
import logo from '../../assets/img/logo.svg';
import styles from './styles.css';
import {
  selectLoading,
} from 'vx-commons/lib/selectors';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      password: '',
      release: {},
      submitted: false,
    };
  }

  componentDidMount() {
    request('/release.json',
      { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((release) => {
        if (!release.err) {
          this.setState({release: release.data});
        }
      })
  }

  handleLogin = (e) => {
    const { user, password } = this.state;

    e.preventDefault();
    this.props.submitLogin(user.trim(), password);
    this.setState({ submitted: true });
  }

  handleUserChange = (event) => {
    this.setState({ user: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  render() {
    const { release } = this.state;
    const { loading} = this.props;

    if(loading) {
      return spinner();
    }

    let chromeOptimizationMessage = ''
    if (window && window.chrome === undefined) {
      chromeOptimizationMessage = 'This portal has been optimized for Chrome Browser, if you\'re facing any issues try using Chrome before contacting support.'
    }

    return (
      <Flex align="center" className={styles.loginWrap}>
        <Growler />
        <Box className={styles.login}>
          <div style={{ textAlign: 'center' }}>
            <img src={logo} alt="Vx Admin" />
          </div>
          <form onSubmit={this.handleLogin} style={{ width: '100%' }}>
            <div className={styles.wrap}>
              <label className={styles.label}>Username</label>
              <input
                className={styles.input}
                id="username"
                type="text"
                value={this.state.user}
                onChange={this.handleUserChange}
                autoFocus
              />
            </div>
            <br />
            <div className={styles.wrap}>
              <label className={styles.label}>Password</label>
              <input
                className={styles.input}
                id="password"
                type="password"
                value={this.state.password}
                onChange={this.handlePasswordChange}
              />
            </div>

            <div style={{ padding: '2em' }}>
              <div>
                <Button
                  label="LOGIN"
                  type="submit"
                  style={{ width: '73px', display: 'block', margin: '0 auto' }}
                />
              </div>
              <Link
                to="/request_password_recovery"
                style={
                  {
                    display: 'block',
                    margin: '40px auto',
                    textAlign: 'center',
                    color: '#68689e'
                  }
                }
              >
                Forgot your password?
              </Link>
              <div style={{ textAlign: 'center', color: 'grey', fontSize: '12px' }}>
                {chromeOptimizationMessage}
              </div>
            </div>
          </form>
        </Box>
        <div className={styles.version}>
          {release.version||''}
        </div>
      </Flex>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  loading: selectLoading(),
});

Login.propTypes = {
  submitLogin: PropTypes.func,
};

export default connect(
  mapStateToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/index.js